import moment, { isMoment, Moment } from "moment"
import "moment/locale/de"
import "moment/locale/en-gb"
import React, { ChangeEvent } from "react"
import { BsX } from "react-icons/bs"
import Datetime from "react-datetime"
import "react-datetime/css/react-datetime.css"
import { EventBus } from "../eventbus"
import i18n from "../i18n"
import { CustomFieldContext } from "../contexts/CustomConfigContext"

export interface DateEditProps {
    modelPath?: string
    id?: string
    value?: Moment | string | null | undefined
    onChange?: (date: string) => void
    readonly?: boolean
}

interface DateEditState {
    value: Moment | string | null | undefined
}

export class DateEdit extends React.Component<DateEditProps, DateEditState> {
    static contextType = CustomFieldContext

    constructor(props: DateEditProps) {
        super(props)
        const date = this.props.value
        this.state = {
            value: undefined,
        }
        // try parse the date, if its a moment, set it to interal value
        if (date && date !== null) {
            const momentDate = moment.utc(date, true)
            if (momentDate.isValid()) {
                this.state = {
                    value: momentDate,
                }
            }
        }
    }
    isoformat = "YYYY-MM-DD"

    componentDidUpdate(prevProps: { value: string | moment.Moment | null | undefined }, prevState: { value: string | moment.Moment | null | undefined }) {
        // state has regular date inside, props changing
        if (prevState.value == this.state.value && prevProps.value !== this.props.value) {
            // state is same but props have changed... -> change state
            if (this.props.value) {
                const momentDate = moment.utc(this.props.value, true)
                if (momentDate.isValid()) {
                    this.setState({
                        value: momentDate,
                    })
                }
            } else {
                this.setState({
                    value: undefined,
                })
            }
        } else if (!moment.isMoment(this.state.value) && this.state.value === prevState.value && this.state.value != this.props.value) {
            const newDate = moment.utc(this.props.value, true)
            this.setState({
                value: this.props.value && newDate.isValid() ? newDate : undefined,
            })
        }
    }

    onChangeHandler = (onChange: { (event: any): void; (arg0: React.ChangeEvent<any>): void }) => (selected: string | Moment) => {
        onChange({ target: { value: selected } } as ChangeEvent<any>)
    }

    onChange = (path?: string) => (event: any) => {
        const date = event.target.value

        this.setState({
            value: date,
        })

        if (this.props.onChange) {
            this.props.onChange.call(this, date)
        }

        if (path) {
            const fieldValue = date && isMoment(date) ? date?.format(this.isoformat) : undefined
            EventBus.instance.emit("changeProperty", path, fieldValue)
        }
    }

    onClear = (path?: string) => () => {
        this.setState({
            value: undefined,
        })

        if (path) EventBus.instance.emit("changeProperty", path, null)
    }

    // TODO: geht ggf nicht, frag mal jemanden, wie das richtig geht!
    renderInput(value: Moment | string | undefined, currentClass: DateEdit) {
        const readonly = (this.context as any)?.disabled ?? !!this.props.readonly
        return function datefunction(
            props: React.JSX.IntrinsicAttributes & React.ClassAttributes<HTMLInputElement> & React.InputHTMLAttributes<HTMLInputElement>,
        ) {
            const format = moment.localeData(i18n.language).longDateFormat("L")
            return (
                <>
                    <input {...props} value={value && isMoment(value) ? value.format(format) : value} className={"form-control"} />
                    <button
                        type="button"
                        className="btn btn-link cal-clear-button"
                        disabled={readonly}
                        onClick={currentClass.onClear(currentClass.props.modelPath)}
                    >
                        <BsX size={24} />
                    </button>
                    <i className="bi bi-calendar"></i>
                </>
            )
        }
    }

    render() {
        const readonly = (this.context as any)?.disabled ?? !!this.props.readonly
        const value = this.state.value || ""
        const path = this.props.modelPath

        const inputProps = {
            id: this.props.id,
            disabled: readonly,
        }

        return (
            <Datetime
                locale={i18n.language}
                timeFormat={false}
                input={true}
                inputProps={inputProps}
                className="btn-group w-100"
                value={value}
                utc={true}
                onChange={this.onChangeHandler(this.onChange(path))}
                closeOnSelect={true}
                renderInput={this.renderInput(value, this)}
            />
        )
    }
}
